import { FormEvent, useEffect, useMemo, useRef, useState } from "react";
import {
  Alert,
  Autocomplete,
  Box,
  Button,
  FormControl,
  Grid,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { useReactToPrint } from "react-to-print";

import FileImportOrders from "components/FileImport/FileImportOrders";
import AdditionalItemsList from "components/Operations/AdditionalItemsList";
// Codigo nuevo de adicionales en pedidos comentado 
// import MovementAdditionalItemsStepModal, {
//   MovementAdditionalItemsConfirmPayload,
// } from "components/Operations/MovementAdditionalItemsStepModal";
import OrderArticlesList from "components/Orders/OrderArticlesList";
import OrderFileUpload from "components/Orders/OrderFileUpload";
import OrdersWorkflowList from "components/Orders/OrdersWorkflowList";
import Loader from "components/Loader";
import { PrintLayout } from "components/Prints/PrintLayout";
import OperationPrintDetails from "components/Prints/Operations/OperationPrintDetails";
import OperationPrintHeaderDetails from "components/Prints/Operations/OperationPrintHeaderDetails";
import { OperationPrintTotals } from "components/Prints/Operations/OperationPrintTotal";
import PageLayout from "components/layout/PageLayout";
import { defaultMovement, ORDER_SOURCES, STATUS_CODES } from "constants/index";
// Codigo nuevo de adicionales en pedidos comentado 
// import { MovementTypes } from "constants/index";
import { ORDERS_URL } from "constants/urls";
// Codigo nuevo de adicionales en pedidos comentado 
// import { MOVEMENTS_URL } from "constants/urls";
import { buildOrderArticleLineData, shouldResetOrderArticleObservationPreview } from "helpers/orderArticleLineData";
import { getScopedClientIds } from "helpers/clientScope";
import { buildOrderErrorMessage } from "helpers/orders";
import {
  calculateMovementTotals,
  getInitialMovementDateValue,
} from "helpers/movement";
import { dateISOFormat } from "helpers";
// Codigo nuevo de adicionales en pedidos comentado 
// import {
//   buildAdditionalMovementsPayload,
//   getAdditionalItemsModalTitle,
// } from "helpers/additionalMovements";
import { useConfirmationModal } from "hooks/useConfirmationModal";
import useCrud from "hooks/useCrud";
import { useToast } from "hooks/useToast";
import { useSession } from "providers/SessionProvider";
import {
  CreateOrderPayload,
  Movement,
  MovementAdditionalItem,
  Order,
  OrderDraftArticleRow,
} from "types";
// Codigo nuevo de adicionales en pedidos comentado 
// import { dateToMySQLFormat } from "helpers";

type OrderFormState = {
  client_id: number;
  associated_client_id: number | null;
  created_by: number;
  updated_by: number;
  client_document: string;
  numero_remito: string;
  vehicle: string;
  pallets: number | null;
  weight: number | null;
  date: Date | null;
  observation: string;
  articles: OrderDraftArticleRow[];
  additional_items: MovementAdditionalItem[];
};

export default function OrdersPage() {
  const {
    clients,
    associatedClients,
    additionalItems,
    articles,
    stores,
    locations,
    users,
    userData,
  } = useSession();
  const { showSnackBar } = useToast();
  const { showModal } = useConfirmationModal();
  const { createData, loading } = useCrud<any>(ORDERS_URL, {
    disableAutoFetch: true,
  });

  // Codigo nuevo de adicionales en pedidos comentado 
  // const { createData: createMovement } = useCrud<Movement[]>(MOVEMENTS_URL, {
  //   disableAutoFetch: true,
  // });

  const printRef = useRef(null);

  const [currentTab, setCurrentTab] = useState(0);
  const [currentManualContentTab, setCurrentManualContentTab] = useState(0);
  const [nextRowId, setNextRowId] = useState(2);
  const [additionalItemRowIndex, setAdditionalItemRowIndex] = useState(0);
  // Codigo nuevo de adicionales en pedidos comentado 
  // const [additionalItemsModalOpen, setAdditionalItemsModalOpen] = useState(false);
  const [lastCreatedOrderId, setLastCreatedOrderId] = useState<number | null>(
    null,
  );
  const [orderToPrint, setOrderToPrint] = useState<Order | null>(null);
  // Codigo nuevo de adicionales en pedidos comentado 
  // const [movementToPrint, setMovementToPrint] = useState<Movement | null>(null);
  // const [additionalMovementsToPrint, setAdditionalMovementsToPrint] = useState<Movement[]>([]);
  const [form, setForm] = useState<OrderFormState>({
    client_id: 0,
    associated_client_id: null as number | null,
    created_by: userData?.id ?? 0,
    updated_by: userData?.id ?? 0,
    client_document: "",
    numero_remito: "",
    vehicle: "",
    pallets: null,
    weight: null,
    date: getInitialMovementDateValue(),
    observation: "",
    articles: [],
    additional_items: [],
  });

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    onAfterPrint: () => {
      // Codigo nuevo de adicionales en pedidos comentado 
      // if (additionalMovementsToPrint.length > 0) {
      //   const [nextMovementToPrint, ...remainingMovementsToPrint] =
      //     additionalMovementsToPrint;
      //
      //   setAdditionalMovementsToPrint(remainingMovementsToPrint);
      //   setOrderToPrint(null);
      //   setMovementToPrint(nextMovementToPrint);
      //   return;
      // }

      if (orderToPrint?.id) {
        showSnackBar(`Pedido #${orderToPrint.id} creado correctamente.`, "success");
      } else {
        showSnackBar("Pedido creado correctamente.", "success");
      }

      setOrderToPrint(null);
      // Codigo nuevo de adicionales en pedidos comentado 
      // setMovementToPrint(null);
    },
  });

  const activeClients = useMemo(
    () => clients.filter((client) => client.is_active && client.parent_client_id == null),
    [clients],
  );

  const selectedClient = useMemo(
    () => activeClients.find((client) => client.id === form.client_id) ?? null,
    [activeClients, form.client_id],
  );

  const selectedAssociatedClient = useMemo(
    () =>
      associatedClients.find(
        (associatedClient) =>
          associatedClient.id === form.associated_client_id &&
          associatedClient.client_id === form.client_id,
      ) ?? null,
    [associatedClients, form.associated_client_id, form.client_id],
  );

  const scopedClientIds = useMemo(
    () => getScopedClientIds(clients, form.client_id),
    [clients, form.client_id],
  );

  // Codigo nuevo de adicionales en pedidos comentado 
  // const childClients = useMemo(
  //   () =>
  //     clients.filter((client) => client.parent_client_id === form.client_id),
  //   [clients, form.client_id],
  // );

  const clientAssociatedClients = useMemo(
    () =>
      associatedClients.filter(
        (associatedClient) =>
          associatedClient.client_id === form.client_id &&
          associatedClient.is_active,
      ),
    [associatedClients, form.client_id],
  );

  const clientArticles = useMemo(
    () =>
      articles.filter(
        (article) =>
          scopedClientIds.includes(article.client_id) && !article.deleted_at,
      ),
    [articles, scopedClientIds],
  );

  const filteredUsers = useMemo(
    () =>
      users.map((user) => ({
        id: user.id,
        label: `${user.first_name} ${user.last_name}`,
      })),
    [users],
  );

  const selectedPreparedBy = useMemo(
    () => filteredUsers.find((user) => user.id === form.updated_by) ?? null,
    [filteredUsers, form.updated_by],
  );

  const selectedCreatedBy = useMemo(
    () => filteredUsers.find((user) => user.id === form.created_by) ?? null,
    [filteredUsers, form.created_by],
  );

  const totals = useMemo(() => {
    return form.articles.reduce(
      (acc, row) => {
        const article = clientArticles.find(
          (currentArticle) => currentArticle.id === row.article_id,
        );

        acc.totalPallets += Number(row.amount) || 0;
        acc.totalWeight += (Number(row.amount) || 0) * Number(article?.weight ?? 0);

        return acc;
      },
      {
        totalPallets: 0,
        totalWeight: 0,
      },
    );
  }, [clientArticles, form.articles]);

  const movementTotals = useMemo(
    () =>
      calculateMovementTotals({
        articles: form.articles.map((articleRow) => {
          const amount = Number(articleRow.amount) || 0;
          const amountPerContainer =
            Number(articleRow.amount_per_container) || 0;

          return {
            amount,
            subtotal: amount * amountPerContainer,
          };
        }),
      }),
    [form.articles],
  );

  const orderMovementForAdditionalItems = useMemo<Movement>(
    () => ({
      ...defaultMovement,
      date: form.date?.toISOString() ?? "",
      client_id: form.client_id,
      associated_client: selectedAssociatedClient?.razon_social ?? "",
      client_document: form.client_document,
      numero_remito: form.numero_remito,
      vehicle: form.vehicle,
      observation: form.observation,
      created_by: form.created_by,
      updated_by: form.updated_by,
      additional_items: form.additional_items,
    }),
    [
      form.additional_items,
      form.client_id,
      form.client_document,
      form.created_by,
      form.date,
      form.numero_remito,
      form.vehicle,
      form.observation,
      form.updated_by,
      selectedAssociatedClient,
    ],
  );

  const handleHeaderChange = <K extends keyof OrderFormState>(
    field: K,
    value: OrderFormState[K],
  ) => {
    setForm((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleClientChange = (clientId: number) => {
    setLastCreatedOrderId(null);
    setForm((prev) => ({
      ...prev,
      client_id: clientId,
      associated_client_id: null,
      client_document: "",
      pallets: null,
      weight: null,
      articles: [],
      additional_items: [],
    }));
    setNextRowId(1);
    setAdditionalItemRowIndex(0);
  };

  const handleAddArticleRow = (
    row: Omit<OrderDraftArticleRow, "localId">,
  ) => {
    setLastCreatedOrderId(null);
    setForm((prev) => ({
      ...prev,
      articles: [...prev.articles, { localId: nextRowId, ...row }],
    }));
    setNextRowId((prev) => prev + 1);
  };

  const handleEditArticleRow = (updatedRow: OrderDraftArticleRow) => {
    setLastCreatedOrderId(null);
    setForm((prev) => ({
      ...prev,
      articles: prev.articles.map((row) =>
        row.localId !== updatedRow.localId
          ? row
          : shouldResetOrderArticleObservationPreview(row, updatedRow)
            ? {
                ...updatedRow,
                stock_unit_selection: undefined,
                observation_preview_units: undefined,
              }
            : updatedRow,
      ),
    }));
  };

  const handleDeleteArticleRows = (localIds: number[]) => {
    setLastCreatedOrderId(null);
    setForm((prev) => {
      return {
        ...prev,
        articles: prev.articles.filter((row) => !localIds.includes(row.localId)),
      };
    });
  };

  useEffect(() => {
    if (!userData) {
      return;
    }

    setForm((prev) => ({
      ...prev,
      created_by: prev.created_by || userData.id,
      updated_by: prev.updated_by || userData.id,
    }));
  }, [userData]);

  const buildPayload = (): CreateOrderPayload | null => {
    if (!form.client_id) {
      showSnackBar("Debe seleccionar un cliente.", "warning");
      return null;
    }

    if (!form.client_document.trim()) {
      showSnackBar("Debe ingresar el documento del cliente.", "warning");
      return null;
    }

    if (!form.date) {
      showSnackBar("Debe ingresar la fecha del pedido.", "warning");
      return null;
    }

    if (form.articles.length === 0) {
      showSnackBar("Debe agregar al menos un articulo.", "warning");
      return null;
    }

    if (!form.updated_by) {
      showSnackBar("Debe seleccionar quién preparó el pedido.", "warning");
      return null;
    }

    const invalidRowIndex = form.articles.findIndex(
      (articleRow) =>
        !articleRow.article_id ||
        !articleRow.location_id ||
        !Number.isInteger(Number(articleRow.amount)) ||
        Number(articleRow.amount) <= 0 ||
        Number(articleRow.amount_per_container) <= 0,
    );

    if (invalidRowIndex !== -1) {
      showSnackBar(
        `Revise el articulo ${invalidRowIndex + 1}. Debe tener artículo, ubicación, cantidad y cantidad por contenedor válidas.`,
        "warning",
      );
      return null;
    }

    return {
      client_id: form.client_id,
      client_document: form.client_document.trim() || null,
      associated_client_id: form.associated_client_id,
      updated_by: form.updated_by,
      numero_remito: form.numero_remito.trim(),
      vehicle: form.vehicle.trim() || null,
      pallets: form.pallets ?? totals.totalPallets,
      weight: form.weight ?? totals.totalWeight,
      received_at: dateISOFormat(form.date.toISOString())!,
      preparation_date: null,
      observation: form.observation.trim() || null,
      source: ORDER_SOURCES.MANUAL,
      articles: form.articles.map((articleRow) => ({
        article_id: articleRow.article_id,
        location_id: articleRow.location_id ?? null,
        amount: Number(articleRow.amount),
        amount_per_container: Number(articleRow.amount_per_container),
        lote: articleRow.lote || null,
        oc: articleRow.oc || null,
        fecha_ingreso: articleRow.fecha_ingreso,
        fecha_vencimiento: articleRow.fecha_vencimiento,
        line_data: buildOrderArticleLineData(articleRow),
        source_row_number: null,
      })),
      additional_items: form.additional_items.map((additionalItem) => ({
        additional_item_id: Number(additionalItem.additional_item_id),
        amount: Number(additionalItem.amount ?? 0),
      })),
    };
  };

  const resetFormAfterSuccess = () => {
    setForm((prev) => ({
      ...prev,
      client_document: "",
      numero_remito: "",
      vehicle: "",
      pallets: null,
      weight: null,
      date: getInitialMovementDateValue(),
      observation: "",
      articles: [],
      additional_items: [],
    }));
    setNextRowId(1);
    setAdditionalItemRowIndex(0);
  };

  const submitOrder = async () => {
    const payload = buildPayload();

    if (!payload) {
      return;
    }

    const response = await createData(payload, true);

    if (response.status === STATUS_CODES.OK) {
      const createdOrder = response.data as Order;
      const createdOrderId = Number(createdOrder?.id ?? 0) || null;

      // Codigo nuevo de adicionales en pedidos comentado 
      // if (createdOrderId && additionalItemsToCreate.length > 0) {
      //   const orderAdditionalBaseMovement: Movement = {
      //     ...defaultMovement,
      //     date: form.date ? dateToMySQLFormat(form.date) : "",
      //     client_id: form.client_id,
      //     client_document: form.client_document,
      //     numero_remito: form.numero_remito,
      //     associated_client:
      //       associatedClients.find(
      //         (client) => client.id === form.associated_client_id,
      //       )?.razon_social ?? "",
      //     created_by: userData?.id ?? 0,
      //     updated_by: form.updated_by ?? userData?.id ?? 0,
      //     store_id: null,
      //     pallets: form.pallets ?? totals.totalPallets,
      //     weight: form.weight ?? totals.totalWeight,
      //     observation: form.observation,
      //     articles: [],
      //     containers: [],
      //     additional_items: [],
      //   };
      //
      //   const additionalMovementsPayload = buildAdditionalMovementsPayload({
      //     baseMovement: orderAdditionalBaseMovement,
      //     headerMovement: additionalMovementHeader,
      //     items: additionalItemsToCreate,
      //     originMovementId: createdOrderId,
      //   });
      //
      //   const additionalMovementResponse = await createMovement(
      //     additionalMovementsPayload,
      //     true,
      //   );
      //
      //   if (additionalMovementResponse.status !== STATUS_CODES.OK) {
      //     showSnackBar(
      //       additionalMovementResponse.data?.message ||
      //         "El pedido se creó, pero no se pudieron crear los adicionales asociados.",
      //       "error",
      //     );
      //     return;
      //   }
      //
      //   if (Array.isArray(additionalMovementResponse.data)) {
      //     setAdditionalMovementsToPrint(additionalMovementResponse.data);
      //   }
      // }

      setLastCreatedOrderId(createdOrderId);
      resetFormAfterSuccess();
      setOrderToPrint(createdOrder ?? null);
      return;
    }

    showSnackBar(
      buildOrderErrorMessage(
        response.data,
        "No se pudo crear el pedido. Intente nuevamente.",
      ),
      "error",
    );
  };

  // Codigo nuevo de adicionales en pedidos comentado 
  // const handleConfirmAdditionalItems = ({
  //   movement: additionalMovementHeader,
  //   items,
  // }: MovementAdditionalItemsConfirmPayload) => {
  //   setAdditionalItemsModalOpen(false);
  //   submitOrder(items, additionalMovementHeader);
  // };

  const handleConfirmSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    const payload = buildPayload();

    if (!payload) {
      return;
    }

    showModal({
      title: "Confirmar",
      message: "Esta accion creara el pedido y realizara la reserva de stock.",
      action: submitOrder,
      // Codigo nuevo de adicionales en pedidos comentado 
      // action: async () => {
      //   setAdditionalItemsModalOpen(true);
      // },
    });
  };

  useEffect(() => {
    if (orderToPrint) {
      handlePrint();
    }

    // Codigo nuevo de adicionales en pedidos comentado 
    // if (orderToPrint || movementToPrint) {
    //   handlePrint();
    // }
  }, [handlePrint, orderToPrint]);

  if (loading) {
    return <Loader />;
  }

  return (
    <PageLayout
      pageTitle="Pedidos"
      pageDesc="Carga manual o masiva de pedidos con reserva automatica de stock"
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              value={currentTab}
              onChange={(_, newValue) => setCurrentTab(newValue)}
            >
              <Tab label="Carga manual" />
              <Tab label="Carga masiva" />
              <Tab label="Listado y preparación" />
            </Tabs>
          </Box>
        </Grid>

        {currentTab === 0 ? (
          <Grid item xs={12}>
            <form onSubmit={handleConfirmSubmit}>
              <Grid container spacing={2}>
                {lastCreatedOrderId && (
                  <Grid item xs={12}>
                    <Alert severity="success">
                      Pedido #{lastCreatedOrderId} creado correctamente.
                    </Alert>
                  </Grid>
                )}

                <Grid item xs={12}>
                  <Typography variant="body2" fontWeight="bold">
                    Carga manual de pedido
                  </Typography>
                </Grid>

                <Grid item xs={12} md={4}>
                  <TextField
                    label="Usuario"
                    value={selectedCreatedBy?.label ?? ""}
                    fullWidth
                    disabled
                  />
                </Grid>

                <Grid item xs={12} md={4}>
                  <FormControl fullWidth margin="none">
                    <Autocomplete
                      autoComplete
                      value={
                        selectedClient
                          ? {
                              id: selectedClient.id,
                              label: `${selectedClient.code} - ${selectedClient.razon_social}`,
                            }
                          : null
                      }
                      options={activeClients.map((client) => ({
                        id: client.id,
                        label: `${client.code} - ${client.razon_social}`,
                      }))}
                      isOptionEqualToValue={(option, value) =>
                        option.id === value.id
                      }
                      onChange={(_, value) => handleClientChange(value?.id ?? 0)}
                      renderInput={(params) => (
                        <TextField {...params} required label="Cliente" />
                      )}
                    />
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={4}>
                  <FormControl fullWidth margin="none">
                    <Autocomplete
                      autoComplete
                      disabled={!form.client_id}
                      value={
                        selectedAssociatedClient
                          ? {
                              id: selectedAssociatedClient.id,
                              label: selectedAssociatedClient.razon_social,
                            }
                          : null
                      }
                      options={clientAssociatedClients.map((associatedClient) => ({
                        id: associatedClient.id,
                        label: associatedClient.razon_social,
                      }))}
                      isOptionEqualToValue={(option, value) =>
                        option.id === value.id
                      }
                      onChange={(_, value) =>
                        handleHeaderChange(
                          "associated_client_id",
                          value?.id ?? null,
                        )
                      }
                      renderInput={(params) => (
                        <TextField {...params} label="Cliente Asociado" />
                      )}
                    />
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={4}>
                  <TextField
                    label="Documento del Cliente"
                    value={form.client_document}
                    onChange={(event) =>
                      handleHeaderChange("client_document", event.target.value)
                    }
                    fullWidth
                    required
                  />
                </Grid>

                <Grid item xs={12} md={4}>
                  <TextField
                    label="Vehiculo"
                    value={form.vehicle}
                    onChange={(event) =>
                      handleHeaderChange("vehicle", event.target.value)
                    }
                    fullWidth
                  />
                </Grid>

                <Grid item xs={12} md={4}>
                  <DatePicker
                    label="Fecha"
                    value={form.date}
                    format="dd/MM/yyyy"
                    onChange={(value) => handleHeaderChange("date", value)}
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        required: true,
                      },
                    }}
                  />
                </Grid>

                <Grid item xs={12} md={4}>
                  <TextField
                    label="Numero de Remito"
                    value={form.numero_remito}
                    onChange={(event) =>
                      handleHeaderChange("numero_remito", event.target.value)
                    }
                    fullWidth
                  />
                </Grid>

                <Grid item xs={12} md={4}>
                  <FormControl fullWidth margin="none">
                    <Autocomplete
                      autoComplete
                      value={selectedPreparedBy}
                      options={filteredUsers}
                      isOptionEqualToValue={(option, value) =>
                        option.id === value.id
                      }
                      disabled={!form.created_by}
                      onChange={(_, value) =>
                        handleHeaderChange("updated_by", value?.id ?? 0)
                      }
                      renderInput={(params) => (
                        <TextField {...params} required label="Preparó" />
                      )}
                    />
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={4}>
                  <TextField
                    label="Pallets"
                    type="number"
                    value={form.pallets ?? totals.totalPallets}
                    onChange={(event) =>
                      handleHeaderChange(
                        "pallets",
                        event.target.value === ""
                          ? null
                          : Number(event.target.value),
                      )
                    }
                    fullWidth
                  />
                </Grid>

                <Grid item xs={12} md={4}>
                  <TextField
                    label="Peso"
                    type="number"
                    value={form.weight ?? totals.totalWeight}
                    onChange={(event) =>
                      handleHeaderChange(
                        "weight",
                        event.target.value === ""
                          ? null
                          : Number(event.target.value),
                      )
                    }
                    fullWidth
                  />
                </Grid>

                <Grid item xs={12} md={4}>
                  <TextField
                    label="Observaciones"
                    value={form.observation}
                    onChange={(event) =>
                      handleHeaderChange("observation", event.target.value)
                    }
                    fullWidth
                  />
                </Grid>

                <Grid item xs={12}>
                  <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                    <Tabs
                      value={currentManualContentTab}
                      onChange={(_, newValue) => setCurrentManualContentTab(newValue)}
                    >
                      <Tab label="Artículos" />
                      <Tab label="Ítems Adicionales" />
                    </Tabs>
                  </Box>
                </Grid>

                <Grid item xs={12} my={2}>
                  {currentManualContentTab === 0 ? (
                    <>
                      <OrderArticlesList
                        rows={form.articles}
                        articles={clientArticles}
                        client={selectedClient}
                        disabled={!form.client_id}
                        onAddRow={handleAddArticleRow}
                        onEditRow={handleEditArticleRow}
                        onDeleteRows={handleDeleteArticleRows}
                      />

                      <Grid container spacing={2} sx={{ mt: 1 }}>
                        <Grid item xs={12} md={4}>
                          <TextField
                            label="Cantidad Total"
                            value={String(movementTotals.totalCantidad)}
                            fullWidth
                            disabled
                          />
                        </Grid>

                        <Grid item xs={12} md={4}>
                          <TextField
                            label="Total Unidad"
                            value={String(movementTotals.totalSubtotalUnidad)}
                            fullWidth
                            disabled
                          />
                        </Grid>
                      </Grid>
                    </>
                  ) : (
                    <AdditionalItemsList
                      additionalItems={additionalItems.filter(
                        (additionalItem) =>
                          additionalItem.client_id == null ||
                          scopedClientIds.includes(additionalItem.client_id),
                      )}
                      movement={orderMovementForAdditionalItems}
                      onMovementUpdate={(name, value) =>
                        handleHeaderChange(
                          name as keyof OrderFormState,
                          value as OrderFormState[keyof OrderFormState],
                        )
                      }
                      rowIndex={additionalItemRowIndex}
                      setRowIndex={setAdditionalItemRowIndex}
                      actionsDisabled={!form.client_id}
                    />
                  )}
                </Grid>

                <Grid item xs={12}>
                  <Button type="submit" variant="contained">
                    Guardar Pedido
                  </Button>
                </Grid>
              </Grid>
            </form>
          </Grid>
        ) : currentTab === 1 ? (
          <Grid item xs={12}>
            <Grid container spacing={2}>

              <Grid item xs={12}>
                <Typography variant="body2" fontWeight="bold">
                  Importacion masiva de pedidos
                </Typography>
              </Grid>

              <Grid item xs={12}>
                <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
                  <FileImportOrders
                    clients={clients}
                    associatedClients={associatedClients}
                    additionalItems={additionalItems}
                    articles={articles}
                    locations={locations}
                    stores={stores}
                    onImported={() => {
                      setCurrentTab(0);
                      setLastCreatedOrderId(null);
                    }}
                  />
                  <OrderFileUpload
                    onCompleted={() => {
                      setLastCreatedOrderId(null);
                      setCurrentTab(2);
                    }}
                  />
                </Box>
              </Grid>
            </Grid>
          </Grid>
        ) : (
          <Grid item xs={12}>
            <OrdersWorkflowList
              clients={clients}
              associatedClients={associatedClients}
              additionalItems={additionalItems}
              articles={articles}
              stores={stores}
              users={users}
            />
          </Grid>
        )}
      </Grid>

      {/* Codigo nuevo de adicionales separados en pedidos comentado por pedido del cliente. */}
      {/* <MovementAdditionalItemsStepModal
        open={additionalItemsModalOpen}
        title={getAdditionalItemsModalTitle({
          ...defaultMovement,
          movement_type_id: MovementTypes.Preparation,
        })}
        movement={{
          ...defaultMovement,
          movement_type_id: MovementTypes.Preparation,
          date: form.date?.toISOString() ?? "",
          client_id: form.client_id,
          associated_client: selectedAssociatedClient?.razon_social ?? "",
          client_document: form.client_document,
          numero_remito: form.numero_remito,
          vehicle: form.vehicle,
          observation: form.observation,
          created_by: form.created_by,
          updated_by: form.updated_by,
          additional_items: [],
        }}
        additionalItems={clientAdditionalItems}
        childClients={childClients}
        associatedClients={associatedClients}
        onClose={() => setAdditionalItemsModalOpen(false)}
        onConfirm={handleConfirmAdditionalItems}
      /> */}

      {orderToPrint && (
        <PrintLayout
          ref={printRef}
          headerInfo={
            <OperationPrintHeaderDetails
              movement={orderToPrint}
              stores={stores}
              movementTypeLabelOverride="pedido"
            />
          }
          footerInfo={<OperationPrintTotals movement={orderToPrint} />}
        >
          <OperationPrintDetails
            movement={orderToPrint}
            client={orderToPrint.client || null}
          />
        </PrintLayout>
      )}

      {/* Codigo nuevo de adicionales separados en pedidos comentado por pedido del cliente. */}
      {/* {movementToPrint && (
        <PrintLayout
          ref={printRef}
          headerInfo={
            <OperationPrintHeaderDetails
              movement={movementToPrint}
              stores={stores}
            />
          }
          footerInfo={<OperationPrintTotals movement={movementToPrint} />}
        >
          <OperationPrintDetails
            movement={movementToPrint}
            client={movementToPrint.client || null}
          />
        </PrintLayout>
      )} */}
    </PageLayout>
  );
}
